import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";
import { Alert, Typography } from "@mui/material";

import { Button } from "@/Components/v2/atoms/Button";

interface MaiteAlertsProps {
  queryLimitReached: boolean;
  remainingQueries: number | null;
  isLoading: boolean;
  hendrenTier: string;
  onLearnMore: () => void;
}

export const MaiteAlerts: React.FC<MaiteAlertsProps> = ({
  queryLimitReached,
  remainingQueries,
  isLoading,
  hendrenTier,
  onLearnMore,
}) => {
  if (isLoading) {
    return null;
  }

  return (
    <>
      {/* Remaining queries alert - only show for FREE tier users */}
      {!queryLimitReached &&
        hendrenTier === "FREE" &&
        remainingQueries !== null &&
        remainingQueries < 3 && (
          <Alert
            severity="info"
            icon={<InfoOutlineIcon />}
            action={
              <Button
                sx={{ backgroundColor: "white", borderRadius: 5, px: 2, py: 1 }}
                onClick={onLearnMore}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "black", textTransform: "none" }}
                  fontWeight={500}
                >
                  Learn More
                </Typography>
              </Button>
            }
            sx={{
              backgroundColor: "#FCE5C4",
              color: "black",
              border: "none",
              borderRadius: 2,
              mb: 2,
              "& .MuiAlert-icon": {
                color: "#D97706",
              },
            }}
          >
            <Typography variant="body2">
              You have {remainingQueries} free MAITE Growth Answers remaining this month.
            </Typography>
          </Alert>
        )}

      {/* Query limit reached alert - only show for FREE tier users */}
      {queryLimitReached && (
        <Alert
          severity="warning"
          icon={<InfoOutlineIcon />}
          action={
            <Button
              sx={{ backgroundColor: "white", borderRadius: 5, px: 2, py: 1 }}
              onClick={onLearnMore}
            >
              <Typography
                variant="body2"
                sx={{ color: "black", textTransform: "none" }}
                fontWeight={500}
              >
                Learn More
              </Typography>
            </Button>
          }
          sx={{
            backgroundColor: "#FCE5C4",
            color: "black",
            border: "none",
            borderRadius: 2,
            mb: 2,
            "& .MuiAlert-icon": {
              color: "#D97706",
            },
          }}
        >
          <Typography variant="body2">
            You have reached your monthly MAITE query limit. Upgrade to unlock unlimited queries.
          </Typography>
        </Alert>
      )}
    </>
  );
};
